import {
  EColumnsHeader,
  IColumnData,
  IDataSource,
} from 'src/app/components/dynamic-table/entities';
import { IPaginator } from 'src/app/shared/model/paginator.model';

export const MOCK_ARIA_LABEL = 'Mock Aria Label';
export const MOCK_COLUMNS_HEADER: EColumnsHeader[] = [
  EColumnsHeader.code,
  EColumnsHeader.name,
];

export const MOCK_COLUMNS_SIMPLE_DATA: IColumnData[] = [
  {
    key: EColumnsHeader.code,
    label: 'Código',
    columnWidth: '100px',
    loaderWidth: '48px',
  },
  {
    key: EColumnsHeader.name,
    label: 'Nome',
    loaderWidth: '150px',
  },
];

export const MOCK_PAGE_SOURCE: IPaginator = {
  currentPage: 1,
  pageSize: 1,
  totalItems: 1,
};

export const MOCK_SIMPLE_DATA_SOURCE: IDataSource[] = [
  {
    id: '1',
    code: '203452',
    name: 'Abastecimento frota',
    deleted: false,
  },
  {
    id: '2',
    code: '667988',
    name: 'Administrativo',
    deleted: false,
  },
  {
    id: '3',
    code: '595022',
    name: 'Caixa',
    deleted: false,
  },
  {
    id: '4',
    code: '458677',
    name: 'Comércio exterior',
    deleted: false,
  },
  {
    id: '5',
    code: '121508',
    name: 'Logistica',
    deleted: false,
  },
  {
    id: '6',
    code: '130923',
    name: 'RH',
    deleted: false,
  },
  {
    id: '7',
    code: '349229',
    name: 'Açougue',
    deleted: false,
  },
];

export const MOCK_MULTI_DATA_SOURCE: IDataSource[] = [
  {
    id: '1',
    deleted: false,
    multi: {
      topInfo: 'SP 01 - São Paulo',
      bottomInfo: '#54 filiais cadastradas',
    },
  },
  {
    id: '2',
    deleted: false,
    multi: {
      topInfo: 'SP 02 - São Paulo',
      bottomInfo: '#54 filiais cadastradas',
    },
  },
  {
    id: '3',
    deleted: false,
    multi: {
      topInfo: 'RJ 01 - Rio de Janeiro',
      bottomInfo: '#54 filiais cadastradas',
    },
  },
  {
    id: '4',
    deleted: false,
    multi: {
      topInfo: 'AM 02 - Amazonas',
      bottomInfo: '#54 filiais cadastradas',
    },
  },
];

export const MOCK_ARCHIVED_DATA_SOURCE: IDataSource[] =
  MOCK_SIMPLE_DATA_SOURCE.map((item) => ({ ...item, deleted: true }));
